import { useState } from 'react';
import { Col, Row } from 'reactstrap';
import Table, { useTable } from 'common/components/table';

import TableActions from 'components/layouts/table';

import edit from 'assets/svg/actions/edit.svg';

import useDrawer from 'common/components/drawer/useDrawer';
import Form from './form';
import EnumsDropdown from '../Dropdown';
import CountrySelector from '@/common/components/selectors/CountrySelector';

const Airlines = () => {
  const [active, setActive] = useState(null);

  const drawer = useDrawer();

  const table = useTable({
    label: 'airlines',
    columns: [
      {
        header: 'Name',
        key: 'name',
        type: 'string',
        sort: true,
        width: 3
      },
      {
        header: 'ICAO DESIGNATOR',
        key: 'icao_code',
        type: 'string',
        sort: true,
        canFilter: true
      },
      {
        header: 'IATA DESIGNATOR',
        key: 'iata_designator',
        type: 'string',
        sort: true,
        canFilter: true
      },
      {
        header: 'IATA AIRLINE ACCOUNTING NUMBER',
        key: '3_digit_code',
        type: 'string',
        sort: true,
        canFilter: true
      },
      {
        header: 'Country',
        key: 'country.name',
        type: 'string',
        sort: true,
        canFilter: false
      },
      {
        header: 'Country',
        key: 'country_id',
        type: 'collection',
        canFilter: true,
        component: CountrySelector,
        componentRest: { isMulti: true },
        hidden: true
      },
      {
        header: 'Actions',
        key: 'actions',
        field: 'actions',
        className: 'text-center',
        width: 1
      }
    ]
  });

  return (
    <Row className="airlines-table">
      <Col xs={12} className="mb-6 mt-n1">
        <TableActions
          documentTitle="Airlines"
          title="Enums"
          dropdown={<EnumsDropdown />}
          actions={[
            { type: 'search' },
            {
              type: 'add',
              text: 'Add Airline',
              color: 'primary',
              onClick: () => {
                setActive(null);
                drawer.open();
              }
            }
          ]}
        />
      </Col>
      <Col xs={12}>
        <Table
          loader
          drawer={<Form drawer={drawer} active={active} refetchData={table.refetchData} />}
          rows={{
            actions: () => ({
              options: [
                {
                  label: 'Edit',
                  icon: edit,
                  onClick: (_, row) => {
                    setActive(row);
                    drawer.open();
                  }
                }
              ]
            })
          }}
          {...table}
        />
      </Col>
    </Row>
  );
};

export default Airlines;
